import './dev/quiet-wds-logs';
import './global.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import ScrollToTop from './components/common/ScrollToTop'; // <-- path

// (Removed 2026-05-26 — was a band-aid global unhandledrejection guard that
// preventDefault'd promise rejections. Added when Matrix setPresence was
// throwing uncaught 429s; that root cause is now fixed at the source
// (matrixUserService.js properly .catch()'s setPresence). Keeping the guard
// after fixing the source might be doing harm: React 19 uses unhandledrejection
// internally for some scheduling / transition cleanup, and preventDefault on
// every rejection — including the harmless aborted-fetch rejections that
// happen during normal route transitions — could be stalling React's commit
// pipeline. If we see another uncaught-rejection symptom, we'll fix it AT
// THE SOURCE rather than globally swallowing.)

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ScrollToTop />   {/* ensures top-of-page on every route change */}
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

